import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const CustomTooltip = (props) => {
  const {
    active,
    classes,
    selectedPairs,
    showMarginValue,
    combinedSelectedPairs,
    subtest,
    translate
  } = props;

  if (active) {
    let limit = 0
    let combinedLimit = 0
    let limitIdx, combinedLimitIdx
    let _selectedPairs = selectedPairs ? selectedPairs.filter(x => x.checked) : []
    let _combinedSelectedPairs = combinedSelectedPairs ? combinedSelectedPairs.filter(x => x.checked) : []

    if (showMarginValue) {
      limitIdx = _selectedPairs.findIndex(x => x.value === 'Limit' && x.checked)
      if (props.payload) {
        limit = limitIdx !== -1 ? props.payload[limitIdx] ? props.payload[limitIdx].value : null : 0
      }
      else {
        limit = null
      }
      if (_combinedSelectedPairs) {
        combinedLimitIdx = (limitIdx !== null || limitIdx !== undefined) ? limitIdx + 1 + _combinedSelectedPairs.findIndex(x => x.value === 'Limit' && x.checked) : null
        if (props.payload) {
          combinedLimit = combinedLimitIdx !== -1 ? props.payload[combinedLimitIdx] ? props.payload[combinedLimitIdx].value : null : 0
        }
        else {
          combinedLimit = null
        }
      }
    }
    if (!props.payload || !props.payload.length) {
      return null
    }

    // let tooltipPoints = [...props.payload]

    return (
      <div className={classes.tooltip}>
        <p>{(Number(props.payload[0].payload.name).toFixed(2))} {translate('worstfrequency')}</p>
        {
          props.payload.map((pair, key) => {
            if (pair.dataKey === 'limit') {
              pair.dataKey = 1;
            }
            let k = _selectedPairs.find(x => x.key === pair.dataKey)
            let l = _combinedSelectedPairs ? _combinedSelectedPairs.find(x => x.key === pair.dataKey - _combinedSelectedPairs[0].tempKey) : null
            let showMargin = showMarginValue;
            if (subtest.startsWith('qualification_') && (limit === null)) {
              showMargin = false
            }
            if (k)
              return (
                <p
                  key={key}>
                  <span
                    style={{
                      color: pair.stroke
                    }}
                    className={classes.label}
                  >
                    {(k.value && k.value.toLowerCase() === "limit") ? (
                      `${translate(k.value.toLowerCase())}: `
                    ) : (`${k.value}: `)
                    }
                  </span>
                  <span
                    className={classes.value}
                    style={{
                      color: pair.stroke
                    }}
                  >
                    {(Number(pair.value).toFixed(2))} {translate('worstvalue')} {(showMargin && (limit !== null || limit !== undefined) && limitIdx !== key) ? ((limitIdx === -1) ? '' :
                      ` (${((subtest === 'ATTEN' || subtest === 'qualification_rl' || subtest === 'qualification_il') ? limit - pair.value : pair.value - limit).toFixed(2)} ${translate('worstvalue')})`
                    ) : ''}
                  </span>
                </p>
              )
            else if (l)
              return (
                <p
                  key={key}>
                  <span
                    style={{
                      color: pair.stroke
                    }}
                    className={classes.label}
                  >
                    {(l.value && l.value.toLowerCase() === "limit") ? (
                      `${translate(l.value.toLowerCase())}: `
                    ) : (`${l.value}: `)
                    }
                  </span>
                  <span
                    className={classes.value}
                    style={{
                      color: pair.stroke
                    }}
                  >
                    {Number(pair.value).toFixed(2)} {translate('worstvalue')} {(showMarginValue && (combinedLimit !== null || combinedLimit !== undefined) && combinedLimitIdx !== key) ? ((combinedLimitIdx === -1) ? '' :
                      (subtest === 'ACRN' && l.value === 'Limit' ? '' : ` (${((subtest === 'ATTEN' || subtest === 'qualification_rl' || subtest === 'qualification_il') ? combinedLimit - pair.value : pair.value - combinedLimit).toFixed(2)} ${translate('worstvalue')})`)
                    ) : ''}
                  </span>
                </p>
              )
            else
              return null
          })
        }
      </div>
    )
  }

  return null
}

export default withStyles(styles)(CustomTooltip)
